module.exports = __webpack_public_path__ + "img/icon-communicate-directly.ace7bf8.svg";